import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Node' })({
    root: {
        display: 'flex',
        alignItems: 'stretch',
        gap: 19,
        position: 'relative'
    },
    line: {
        background: '#4180F0',
        width: 2
    },
    items: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    item: {
        '&:not(:first-child)': {
            marginTop: -5
        },
        '&:not(:last-child)': {
            marginBottom: -5
        }
    },
    operator: {
        position: 'relative',
        left: -20,
        transform: 'translateX(-50%)'
    }
});
